var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-switch',{attrs:{"label":_vm.enabled ? 'Enabled' : 'Disabled',"disabled":_vm.isLoading},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }